module.exports = __webpack_public_path__ + "static/media/icn_parents.b9621476.svg";